type ViteEnv = {
  PROD?: boolean;
  VITE_GTM_CONTAINER_ID?: string;
  VITE_ENV_NAME?: string;
};

const getViteEnv = (): ViteEnv | undefined => {
  if (typeof import.meta === 'undefined') {
    return undefined;
  }

  return (import.meta as unknown as { env?: ViteEnv }).env;
};

export const isProd = (): boolean => {
  const viteEnv = getViteEnv();
  if (typeof viteEnv?.PROD === 'boolean') {
    return viteEnv.PROD;
  }

  return process.env.NODE_ENV === 'production';
};

export const getDeployEnv = (): string | undefined => {
  const viteEnv = getViteEnv();
  return viteEnv?.VITE_ENV_NAME ?? process.env.REACT_APP_ENV_NAME ?? process.env.NODE_ENV;
};

export const getGtmId = (): string | null => {
  const viteEnv = getViteEnv();
  const viteId = viteEnv?.VITE_GTM_CONTAINER_ID;
  if (viteId) {
    return viteId;
  }

  return process.env.REACT_APP_GTM_CONTAINER_ID ?? null;
};

export const isGtmEnabled = (): boolean => {
  const envName = getDeployEnv();
  if (envName === 'staging' || envName === 'prod' || envName === 'production') {
    return true;
  }
  return false;
};
